<template>
  <section>
    <Toolbar />
    <div
      class="
        d-flex
        flex-column
        justify-center
        ma-0
        pa-0
        mt-md-5 mt-lg-5 mt-xl-5
        mx-3
      "
    >
      <v-row justify="center" class="ma-0 pa-0 mt-2">
        <v-col cols="10" class="ma-0 pa-0">
          <h2 class="texto-titulo text-center font-weight-bold" ref="pagina">
            Captura tu comprobante de domicilio
          </h2>
        </v-col>
      </v-row>

      <v-row justify="center" class="ma-0 pa-0 mt-4 mx-3">
        <v-col cols="12" md="10" class="ma-0 pa-0">
          <v-alert
            outlined
            dense
            color="info"
            icon="mdi-information-outline"
            class="alerta-opcional"
          >
            <!-- <div class="font-weight-bold mb-1">Documento opcional</div>
            <div class="text-body-2">
              Si no cuentas con tu comprobante de domicilio en este momento, no
              te preocupes. Podrás continuar con tu solicitud y te lo
              solicitaremos al final.
            </div> -->
          </v-alert>
        </v-col>
      </v-row>

      <v-row justify="center" class="ma-0 pa-0 mt-2 mx-3">
        <v-col
          cols="12"
          md="10"
          class="ma-0 pa-0 text-body-2 grey--text text--darken-2"
        >
          <p class="ma-0 font-weight-bold">Requisitos:</p>
          <ul>
            <li>Imagen clara.</li>
            <li>Datos legibles.</li>
            <li>Comprobante no mayor a 3 meses.</li>
          </ul>
        </v-col>
      </v-row>

      <template v-if="esMobile">
        <v-row justify="center" class="mt-6">
          <v-col cols="10">
            <v-card
              color="grey lighten-3"
              elevation="4"
              class="preview-card d-flex flex-row justify-center align-center"
            >
              <v-icon v-if="!imagen" color="grey darken-1" size="120">
                mdi-file-document-image-outline
              </v-icon>
              <v-card v-else flat class="preview-image-card">
                <v-img height="250px" contain :src="imagen"></v-img>
              </v-card>
            </v-card>
          </v-col>
        </v-row>

        <v-row justify="center" class="ma-0 pa-0 mt-6">
          <v-col cols="12" class="ma-0 pa-0">
            <input
              type="file"
              name="foto"
              id="foto"
              accept="image/*"
              capture="environment"
              @change="cargarFoto"
              ref="inputFotografia"
              hidden
            />

            <div
              v-if="!imagen"
              class="d-flex flex-column justify-center align-center"
            >
              <v-btn
                @click="$refs.inputFotografia.click()"
                fab
                color="primary"
                x-large
              >
                <v-icon>mdi-camera</v-icon>
              </v-btn>
              <p class="texto-ayuda mt-3 mb-0">Toma o carga una fotografía</p>
            </div>

            <div
              class="
                d-flex
                flex-column flex-sm-row
                justify-center
                align-center
                mt-2
              "
              v-else
            >
              <v-btn
                color="primary"
                text
                @click="$refs.inputFotografia.click()"
                plain
                ref="botonVolverACapturar"
                class="mb-3 mb-sm-0 mr-sm-3"
              >
                Volver a capturar
              </v-btn>

              <v-btn
                color="primary"
                @click="navegarACorreoOSiguiente"
                elevation="3"
              >
                Continuar
                <v-icon right light>mdi-arrow-right</v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </template>

      <template v-else>
        <v-row justify="center" class="mt-6">
          <v-col cols="10">
            <v-card
              v-if="!esCamaraDesktopActiva"
              color="grey lighten-3"
              elevation="4"
              class="
                foto-cargada-desktop
                preview-card
                d-flex
                flex-row
                justify-center
                align-center
              "
            >
              <v-icon v-if="!imagen" color="grey darken-1" size="120">
                mdi-file-document-image-outline
              </v-icon>
              <v-card v-else flat class="preview-image-card">
                <v-img height="300px" contain :src="imagen"></v-img>
              </v-card>
            </v-card>
          </v-col>
        </v-row>

        <v-row justify="center" class="ma-0 pa-0">
          <v-col cols="12" class="ma-0 pa-0">
            <v-easy-camera
              v-if="esCamaraDesktopActiva"
              @input="cargarFotoDesktop"
              v-model="imagen"
              ref="camaraDesktop"
            ></v-easy-camera>

            <div
              v-if="!imagen"
              class="d-flex flex-column justify-center align-center my-5"
            >
              <v-btn
                @click="tomarFotoDesktop(false)"
                fab
                color="primary"
                x-large
              >
                <v-icon>mdi-camera</v-icon>
              </v-btn>
              <p class="texto-ayuda mt-3 mb-0">Captura una fotografía</p>
            </div>

            <div
              class="
                d-flex
                flex-column flex-sm-row
                justify-center
                align-center
                my-5
              "
              v-else
            >
              <v-btn
                color="primary"
                text
                @click="tomarFotoDesktop(true)"
                ref="botonVolverACapturar"
                plain
                class="mb-3 mb-sm-0 mr-sm-3"
              >
                Volver a capturar
              </v-btn>

              <v-btn
                color="primary"
                @click="navegarACorreoOSiguiente"
                elevation="3"
              >
                Continuar
                <v-icon right light>mdi-arrow-right</v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </template>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import EasyCamera from 'easy-vue-camera'
import Toolbar from '@/components/compartidos/Toolbar.vue'
import { convertirArchivoABase64 } from '../../utilidades/utilidades.js'
import { NavegacionCorreoMixin } from '@/mixins/credito/NavegacionCorreo.mixin'
import store from '@/store'

export default {
  components: { Toolbar, 'v-easy-camera': EasyCamera },
  mixins: [NavegacionCorreoMixin],
  name: 'CargaComprobanteDom',
  beforeRouteEnter(to, from, next) {
    if (store.getters['persona/obtenerDomicilioCoincideIne'] === true) {
      const emailExiste = store.getters['persona/obtenerEmailExiste']
      const emailValidado = store.getters['persona/obtenerEmailValidado']
      const bancaActiva = store.getters['persona/obtenerEsBancaActiva']
      const tipoCredito = store.getters['credito/obtenerCredito'].tipoCredito
      let siguienteRuta = bancaActiva
        ? tipoCredito == 245
          ? '/referencia'
          : '/confirmacion'
        : '/contrasena'
      if (emailExiste && emailValidado) {
        next(siguienteRuta)
      } else if (emailExiste && !emailValidado) {
        next('/validar-correo')
      } else {
        next('/correo')
      }
    } else {
      next()
    }
  },
  created() {
    this.$store.commit('ESTABLECER_LAYOUT', 'Layout')
  },
  data: () => {
    return {
      imagen: null,
      imagenDesktop: null,
      esCamaraDesktopActiva: false,
    }
  },
  methods: {
    async cargarFoto(e) {
      let archivos = e.target.files || e.dataTransfer.files
      if (!archivos.length) {
        return
      }

      let imagenBase64 = await convertirArchivoABase64(archivos[0])

      this.$store.commit(
        'personaDocumentos/establecerImgComprobanteDomBase64',
        {
          imagenBase64,
        }
      )

      this.imagen = this.obtenerImgComprobanteDomBase64
    },

    cargarFotoDesktop(imagenBase64) {
      this.$store.commit(
        'personaDocumentos/establecerImgComprobanteDomBase64',
        {
          imagenBase64,
        }
      )

      this.imagen = this.obtenerImgComprobanteDomBase64
      this.esCamaraDesktopActiva = false
      this.$refs.camaraDesktop.close()
    },

    tomarFotoDesktop(volverACapturar) {
      if (volverACapturar) {
        this.imagen = null
      }

      if (this.esCamaraDesktopActiva === false) {
        this.esCamaraDesktopActiva = true
        return
      } else {
        this.$refs.camaraDesktop.snap()
      }
    },
  },
  computed: {
    esMobile() {
      var isMobile = false
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
          navigator.userAgent
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw(n|u)|c55\/|capi|ccwa|cdm|cell|chtm|cldc|cmd|co(mp|nd)|craw|da(it|ll|ng)|dbte|dcs|devi|dica|dmob|do(c|p)o|ds(12|d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(|_)|g1 u|g560|gene|gf5|gmo|go(\.w|od)|gr(ad|un)|haie|hcit|hd(m|p|t)|hei|hi(pt|ta)|hp( i|ip)|hsc|ht(c(| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i(20|go|ma)|i230|iac( ||\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|[a-w])|libw|lynx|m1w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|mcr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|([1-8]|c))|phil|pire|pl(ay|uc)|pn2|po(ck|rt|se)|prox|psio|ptg|qaa|qc(07|12|21|32|60|[2-7]|i)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h|oo|p)|sdk\/|se(c(|0|1)|47|mc|nd|ri)|sgh|shar|sie(|m)|sk0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h|v|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl|tdg|tel(i|m)|tim|tmo|to(pl|sh)|ts(70|m|m3|m5)|tx9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas|your|zeto|zte/i.test(
          navigator.userAgent.substr(0, 4)
        )
      ) {
        isMobile = true
      }
      return isMobile
    },

    ...mapGetters({
      obtenerImgComprobanteDomBase64:
        'personaDocumentos/obtenerImgComprobanteDomBase64',
    }),
  },
  mounted() {
    this.imagen =
      this.$store.getters['personaDocumentos/obtenerImgComprobanteDomBase64']
  },
}
</script>

<style>
.imagen-zoom {
  max-width: 100%;
  max-height: 250px !important;
  height: 250px !important;
  object-fit: cover;
}

.foto-cargada-desktop {
  height: 300px;
}

.alerta-opcional {
  border-radius: 12px;
}

.preview-card {
  min-height: 250px;
  border-radius: 16px;
}

.preview-image-card {
  width: 100%;
  background: transparent !important;
  box-shadow: none !important;
}

.texto-ayuda {
  font-size: 14px;
  color: #616161;
  text-align: center;
}
</style>
